/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

import * as React from 'react';
import { ICittaProductEoqViewProps } from './citta-product-eoq';

export default (props: ICittaProductEoqViewProps) => {
    const {
        EoqContainer,
        QuantityTitleTextNode,
        AvailableTitleTextNode,
        QuantityNode,
        AvailableNode
    } = props;
    return (
        <Module {...EoqContainer}>
            <div>
                
                <Node {...QuantityTitleTextNode} />
                <Node {...QuantityNode} />
            </div>
            <div>
                <Node {...AvailableTitleTextNode} />
                <Node {...AvailableNode} />
            </div>
        </Module>
    );
};
